export const validation = {
  email: 'Email is required',
  validEmail: 'Please enter valid email address',
  password: 'Password is required',
  minValidPassword: 'Password at least 6 characters long.',
  maxValidPassword: 'Please enter less than 16 characters.',
  selectAdministrator: 'Please select the administrator',
};
